"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const every_1 = __importDefault(require("lodash/every"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/**
 * Checks if filter criteria is empty
 * @param {Object} filterCriteria
 */
function isFilterCriteriaEmpty(filterCriteria) {
    return (0, every_1.default)(filterCriteria, (value) => {
        return (0, isEmpty_1.default)(value);
    });
}
exports.default = isFilterCriteriaEmpty;
